import { render, staticRenderFns } from "./OpenField.vue?vue&type=template&id=90ff150c&scoped=true"
import script from "./OpenField.vue?vue&type=script&lang=js"
export * from "./OpenField.vue?vue&type=script&lang=js"
import style0 from "./OpenField.vue?vue&type=style&index=0&id=90ff150c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ff150c",
  null
  
)

export default component.exports